var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-download" }, [
    _c(
      "div",
      { class: { "st-show": _vm.isWechat }, attrs: { id: "dimmed-wechat" } },
      [
        _c("img", {
          attrs: { src: require("@/assets/download/img_open_browser.png") },
        }),
      ]
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "download__pageview" } }, [
      _c("img", {
        staticClass: "img-bg",
        attrs: { src: require("@/assets/download/img-home-top.svg"), alt: "" },
      }),
      _vm._v(" "),
      _c("header", { staticClass: "download__header" }, [
        _c("img", {
          staticClass: "english-logo",
          attrs: { src: require("@/assets/download/img-coupon-logo-cn.png") },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pageview__content" }, [
        _c("h1", { staticClass: "download__title" }, [
          _vm._v("\n                爱上英语 快乐空间\n            "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "download__biglogo" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/download/img-home-cn-logo.png"),
              alt: "Todo English Main Banner Logo",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "download__buttons" }, [
          _c(
            "a",
            {
              staticClass: "download__appstore",
              attrs: {
                href: "https://apps.apple.com/cn/app/id1500379448",
                target: "_blank",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/download/img-appstore-wh.png"),
                  alt: "",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "download__moredetail",
            attrs: {
              href: "http://mp.weixin.qq.com/s?__biz=MzA5MjkxMzY1NA==&mid=2247485550&idx=2&sn=6b4ee275eaa2848592e46c75382c3adc&chksm=9064a2f7a7132be1c53e747aae2d47a27580c6710cbf8a783695965ec49fb6a41d4d66b6ee97&scene=18#wechat_redirect",
              target: "_blank",
            },
          },
          [
            _vm._v("\n                查看都都GO详细介绍\n                "),
            _c("img", {
              staticClass: "img_homepage_arrow",
              attrs: {
                src: require("@/assets/download/img-homepage-arrow.svg"),
              },
            }),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }